module.exports = __webpack_public_path__ + "static/amazon-positive-reviews-5eff82bec924d62f90a6e43e5316dd90.png";